export default "__VITE_ASSET__fbf97b99__"